import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import VersionInfoRow, {VersionInfoRowProps} from './VersionInfoRow';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState, ownProps: any): Partial<VersionInfoRowProps> => {
   return {
      history: ownProps.history,
      location: ownProps.location,
      match: ownProps.match,
      isSelected: ownProps.isSelected,
      reviewVersion: ownProps.versionInfo,
      review: state.currentReview,
      currentReviewVersion: state.currentReviewVersion,
      deleteVersion: ownProps.deleteVersion
   };
};

export default withRouter(connect(mapStateToProps, null)(VersionInfoRow));
